<mat-card appearance="outlined" *ngIf="!!dynamicContent">
  <smart-input [hideDescription]="true" [model]="dynamicContent.content" translationKey="dynamicContent.phone" [key]="'phone'"></smart-input>
  <smart-input [hideDescription]="true" [model]="dynamicContent.content" translationKey="dynamicContent.email" [key]="'email'"></smart-input>
  <smart-input [hideDescription]="true" [model]="dynamicContent.content" translationKey="dynamicContent.website" [key]="'website'"></smart-input>
</mat-card>
